<template>
  <div class="place" :class="{ expanded: expanded }">
    <div class="header">
      <img class="name-tag-place" :src="getImg(place.name)" />
      <img class="picture place-img place-img--effect" :class="rotate" :src="getImg(place.picture)" />

    </div>
    <div class="place-description" @click="expanded = true">
      
        <p v-if="!expanded" class="place-description-text">{{ place.description[0] }}</p>
      
      <p
        v-else-if="expanded"
        v-for="(line, index) in place.description"
        v-bind:key="index"
        class="place-description-text"
      >
        {{ line }}
      </p>
    </div>
    <button
    class="btn-expand"
      v-if="!expanded"
      @click="expanded = true"
    >
      Les mer
    </button>
  </div>
</template>
<script>
export default {
  props: {
    place: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
  methods: {
    getImg(name) {
      return require("@/assets/places/" + name);
    },
  },
  data() {
    return {
      expanded: false,
      rotate: "",
    };
  },
  mounted: function() {
    if( this.place.id % 2) {
      this.rotate = "odd";
    } else {
      this.rotate = "even";      
    }
  }

};
</script>
<style lang="scss">
.place {
   
  padding: 2rem 0 2rem 0;
  margin: 0 1rem 1rem 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: color('black-3');
  &:first-child {
    margin-top: -1rem;
  }
}

.place-description {
  width: 90%;
  margin: auto;
  @include desktop () {
    width: 80%;
  }
  
}

.place-description-text {
  width: 100%;
  font-size: 1em;
  color: color('text');
  margin: 0;
  margin: 1rem 0;
  line-height: 1.5em;
  &:first-child {
    margin-top: 2rem;
  }
  
}

.name-tag-place {
  height: 60px;
  z-index: 100;
}
.place-img {
  margin-top: -1.6rem;
  width: calc(90% - 16px);
  max-width: 400px;
  filter: drop-shadow(0 0 10px rgb(65, 65, 65));

}

.odd {
  transform: rotate(1deg);
}
.even {
  transform: rotate(-1deg);
}

.place-img--effect {
  //border: 5px solid #fff;
  border: 16px solid;
  border-image: linear-gradient(10deg, #e6e4dd, #e7ede7, #f1f2f1) 1;
}

</style>
 